<template>
        <form class="wrapper-form w-full" @submit.prevent="sendContact">
        <div class="main__search mb-4">
            <div class="gs:grid relative">
                <div class="md:col-4 form-group z-4">
                    <label class="form-label" for="brands_select">
                        Marca
                    </label>
                    <v-select @click.native="loadBrands()"
                        v-model="filters.brands"
                        :reduce="brands => brands.value"
                        :options="getBrands()"
                        placeholder="Seleccionar"
                        label="name"
                        class="form-input" name="brands" id="brands_select" >
                        <span slot="no-options"> {{ brandsLoads && getBrands().length == 0 ? 'Sin resultados' : 'Cargando...'  }} </span>
                    </v-select>
                </div>
                <div class="md:col-4 form-group z-3">
                    <label class="form-label" for="models_select">
                        Modelo
                    </label>
                    <v-select
                        v-model="filters.models"
                        :reduce="models => models.value"
                        :options="getModels()"
                        placeholder="Seleccionar"
                        label="name"
                        class="form-input" name="models" id="models_select" >
                        <span slot="no-options">{{ modelsLoads && getBrands().length == 0 ? 'Sin resultados' : 'Cargando...'  }}</span>
                    </v-select>
                </div>
                <div class="md:col-4 form-group z-2">
                    <label class="form-label" for="models_select">
                        Intención de compra
                    </label>
                    <v-select
                        placeholder="Seleccionar"
                        label="name"
                        class="form-input"
                        :options="datesPurchase"
                        v-model="buyPlan">
                    </v-select>
                </div>
                <div class="md:col-4 form-group">
                    <label class="form-label" for="zip-code">
                        C.P.
                    </label>
                    <the-mask id="zip-code" class="form-input" type="tel" v-model="filters.zip_code" placeholder="00000" :masked="false" mask="#####"></the-mask>
                </div>
            </div>
        </div>
        <div class="form-grid -mx-2">
            <div class="form-group sm:col-6">
                <input class="form-input bg-white" type="text" placeholder="Nombre completo" v-model="name">
            </div>
            <div class="form-group sm:col-6">
                     <the-mask
                            class="form-input"
                            type="tel"
                            v-model="phone"
                            placeholder="Celular a 10 dígitos"
                            :masked="false"
                            mask="##-##-##-##-##"
                        ></the-mask>
            </div>
            <div class="form-group sm:col-4">
                <input class="btn btn--green-ad sm:h-full w-full" type="submit" value="Enviar">
            </div>
        </div>
    </form>
</template>

<script>
    import { mapState } from 'vuex';
    import vSelect from 'vue-select';
    import VueSweetalert2 from 'vue-sweetalert2';
    import 'vue-select/dist/vue-select.css';
    import {TheMask} from 'vue-the-mask';
    Vue.component( 'v-select', vSelect );

export default {
    data: () => ({
        currentSearch: '/catalogo',
        datesPurchase:[
            'Inmediato',
            '3 meses',
            '6 meses',
            'Mas de 6 meses'
        ],
        filters: {
            brands: [],
            models: [],
            prices: {
                from: null,
                to: null,
            },
            zip_code: null
        },
        brandsLoads: false,
        modelsLoads: false,
        buyPlan: '',
        name: '',
        phone: ''

    }),

    components: {
        TheMask
    },

    watch: {
        'filters': {
            handler(value){
                this.setQueryToLocation();
            }, deep: true
        },
    },

    methods: {
        loadBrands() {
            this.$store.dispatch('catalog/getBrands');
        },

        getBrands() {
            return _.map(this.$store.state.catalog.brands, function(item, key) {
                return {
                    name: item.title,
                    value: item.id
                };
            });
            this.brandsLoads = true;
        },
        getModels() {
            let vm = this;
            vm.modelsLoads = false;
            let data = _.filter(this.$store.state.catalog.models, function(item, key){
                return item.brand_id === vm.filters.brands;
            });

            return _.map(data, function(item, key) {
                return {
                    name: item.title,
                    value: item.id
                };
            });
            vm.modelsLoads = true;
        },
        getPrice(value) {
            this.filters.prices.to = value;
        },
        setQueryToLocation() {
            let vm = this;
            let CurrentUrl = window.location.origin + '/catalogo';
            let filters = [];

            if ( !!vm.filters["brands"] ) {
                filters.push('brands=' + vm.filters["brands"] );
            }
            if ( !!vm.filters["models"] ) {
                filters.push('models=' + vm.filters["models"] );
            }
            if ( !!vm.filters["zip_code"] ) {
                filters.push('zip_code=' + vm.filters["zip_code"] );
            }
            if ( !!vm.filters["prices"]['from'] || !!vm.filters["prices"]['to']  ) {
                filters.push('prices=from:' + vm.filters["prices"]['from'] + ',to:' + vm.filters["prices"]['to'] );
            }
            let urlSearch = _.join(filters,'&');
            vm.currentSearch = CurrentUrl + '?' + urlSearch;
        },
        getProducts(event) {
            event.preventDefault();
            window.location.href = this.currentSearch;
        },
        async sendContact() {
            if(!this.filters || !this.filters.brands || !this.filters.models || !this.filters.zip_code || this.buyPlan == "" || this.name == '' || this.phone == "") {
                  await this.$swal({
                    icon: "danger",
                    title: "Error",
                    text: "Todos los campos son necesarios",
                    confirmButtonText: 'Aceptar'
                })
                return;
            }

            if(this.phone.length !== 10) {
                  await this.$swal({
                    icon: "danger",
                    title: "Error",
                    text: "El número teléfonico necesita tener 10 dígitos exactamente",
                    confirmButtonText: 'Aceptar'
                })
                return;
            }
            const formData = {
                brand_id : this.filters.brands,
                model_id : this.filters.models,
                zip_code : this.filters.zip_code,
                buy_plan : this.buyPlan,
                name : this.name,
                phone : this.phone
            };
            console.table(formData);
            this.$swal({
                icon: "info",
                title: "Enviando correo...",
                text: "Espere un momento",
            });
            try {
                await axios.post('/contact',formData);
                  await this.$swal({
                    icon: "success",
                    title: "Correo enviado",
                    text: "Gracias",
                    confirmButtonText: 'Aceptar'
                })
                location.reload();
            } catch (error) {}
        }
    }
}
</script>
<style lang="scss" scoped>


    .bg-blur{
        backdrop-filter: blur(10.5px);
    }

    .wrapper-form{
        max-width: 80%;

        @media screen and (min-width: 540px) {
            max-width: 60%;
        }

        @media screen and (min-width: 768px) {
                max-width: 826px;
        }
    }

    .bg-white{
        background-color: #fff!important;
    }

    .form-grid>.col, .form-grid>[class*=col-] {
        padding-right: 8px;
        padding-left: 8px;
    }
</style>
